export default __webpack_public_path__ + "74a3d181f19c28e8e0523133a8a0249f.svg";